import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import MpgInput from "../../../CommonFormComp/MpgInput";
import ClientAccountDetailsFields from "./ClientAccountDetailsFields";
import LogoUploadField from "./LogoUploadField";

const EditClientAccountDetailsSection = ({
  WrapperComponent,
  fetchClientAccountCmsData,
  rhfFormInstance,
  primaryLangAutocompleteList,
  supportiveLangAutocompleteList,
  currencyAutocompleteList,
  clientTypeAutocompleteList,
  selectedPrimaryLang,
  removeLogo,
  setRemoveLogo,
  clientAccountDataById,
  fileDetails,
  downloadLogo,
  isFetchingOnClientCodeList,
  isSuccessOnClientCodeList,
  onOpenClientAccCodeDialog,
}) => {
  return (
    <WrapperComponent>
      <Typography variant="h6" align="left" sx={{ fontWeight: "bolder" }}>
        {fetchClientAccountCmsData("ClientAccountDetails.ClientAccountDetails")}
      </Typography>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <ClientAccountDetailsFields
            rhfFormInstance={rhfFormInstance}
            fetchLabel={fetchClientAccountCmsData}
            primaryLangAutocompleteList={primaryLangAutocompleteList || []}
            supportiveLangAutocompleteList={supportiveLangAutocompleteList || []}
            currencyAutocompleteList={currencyAutocompleteList || []}
            clientTypeAutocompleteList={clientTypeAutocompleteList || []}
            selectedPrimaryLang={selectedPrimaryLang}
          />
          <LogoUploadField
            rhfFormInstance={rhfFormInstance}
            uploadFieldName={"logo_img"}
            uploadLabel={fetchClientAccountCmsData("ClientAccountDetails.Logo")}
            removeLogo={removeLogo}
            setRemoveLogo={setRemoveLogo}
            showExistingLogo={!!clientAccountDataById?.Logo}
            removeLogoTooltip={fetchClientAccountCmsData(
              "ClientAccountDetails.RemoveLogo"
            )}
            logoName={`${clientAccountDataById?.ClientAccountName}_logo`}
            onDownloadLogo={() => {
              if (!!fileDetails?.fileGUID) {
                downloadLogo({
                  fileGUID: fileDetails?.fileGUID,
                  DownloadType: "logo",
                  Extension: fileDetails?.fileExtension,
                });
              }
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <div>
            <MpgInput
              rhfFormInstance={rhfFormInstance}
              label={fetchClientAccountCmsData("ClientAccountDetails.ClientCodes")}
              name={"client_codes"}
              multiline
              rows={8}
              fullWidth
              disabled={true}
            />
            {!!isFetchingOnClientCodeList && (
              <Button disabled>
                <CircularProgress size={15} sx={{ margin: "5px" }} />
                {fetchClientAccountCmsData("ClientAccountDetails.Fetch")}
              </Button>
            )}
            {!!isSuccessOnClientCodeList && (
              <Button onClick={onOpenClientAccCodeDialog}>
                {fetchClientAccountCmsData("ClientAccountDetails.SelectClientCodes")}
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </WrapperComponent>
  );
};

export default EditClientAccountDetailsSection;
